export const steps = [
  { title: 'Step 1', description: 'Select token pair and fees' },
  { title: 'Step 2', description: 'Set price range' },
  { title: 'Step 3', description: 'Create pool' },
  { title: 'Step 4', description: 'Enter deposit amounts' },
]
